export default {
  OPERACION_ENCUESTA: (state, mutation) => {
    state.operacion = mutation.oper
    state.id = mutation.id
  },
}
